export enum PointOfSale {
  Manual = 'MANUAL',
  ZZApp = 'ZZAPP',
  Seta = 'SETA',
  Cigam = 'CIGAM',
  CigamMeiaSola = 'CIGAM_MEIA_SOLA',
}

export enum PointOfSaleType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
}

export type PointOfSaleDetails = {
  isInvoiceGenerator: boolean;
  isTaxCouponGenerator: boolean;
  name: PointOfSale;
  type: PointOfSaleType;
};

export enum PointOfSaleSubmit {
  Manual,
  Invoice,
  Cupom,
}
